import { Zaglavlje } from "./zaglavlje";
import { Zbirni } from "./zbirni";
import { Stavka } from "./stavka";

export class Dokument{

    constructor() {}

    // Zaglavlje: Zaglavlje[] = null;
    // Zbirni: Zbirni[] = null;
    Zaglavlje: Zaglavlje = null;
    Zbirni: Zbirni = null;
    Stavka: Stavka[] = null;

    Deserialize(input:any){
        // this.Zaglavlje=input.Zaglavlje;
        // this.Zbirni = input.Zbirni;
        // this.Stavka = input.Stavka;

        // if (input.Dokument.Zaglavlje!=null){
        //     this.Zaglavlje=[];
        //     this.Zaglavlje.push(new Zaglavlje().Deserialize(input.Dokument.Zaglavlje));
            
        // }
        this.Zaglavlje=new Zaglavlje().Deserialize(input.Dokument.Zaglavlje);

        // if (input.Dokument.Zbirni!=null){
        //     this.Zbirni=[];
        //     this.Zbirni.push(new Zbirni().Deserialize(input.Dokument.Zbirni));
           
        // }
        this.Zbirni=new Zbirni().Deserialize(input.Dokument.Zbirni);

        if (input.Dokument.Stavka!=null){
            this.Stavka=[];
            input.Dokument.Stavka.forEach(Item => {
                return this.Stavka.push(new Stavka().Deserialize(Item))
            });
        }
        return this;
    }

}